import { Button, type ButtonProps } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

interface ActionButtonProps extends Omit<ButtonProps, 'children' | 'icon' | 'type'> {
  icon?: IconDefinition;
  label: string;
}

/**
 * Page-level primary action button — matches the Arbox header pattern:
 *
 *   <div class="custom-button-v2">
 *     <Button type="primary">
 *       <div style="font-family: PloniMedium; color: white;">label</div>
 *     </Button>
 *   </div>
 *
 * Optional FA icon shows next to the label on small screens (the Arbox
 * Expenses "+ הוספת הוצאה חדשה" mobile treatment); on desktop the label
 * is the affordance.
 */
export default function ActionButton({ icon, label, ...rest }: ActionButtonProps) {
  return (
    <div className="custom-button-v2">
      <Button type="primary" aria-label={label} {...rest}>
        {icon ? (
          <FontAwesomeIcon icon={icon} className="sm:hidden" style={{ fontSize: 16 }} />
        ) : null}
        <span className={icon ? 'hidden sm:inline' : undefined} style={{ fontWeight: 500 }}>
          {label}
        </span>
      </Button>
    </div>
  );
}
